import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import React from 'react';

const CustomAlert = ({isOpen, closeAlert, severity, text}) => {
  return (
    <Collapse in={isOpen}>
      <Alert
        severity={severity}
        action={
          <IconButton size="small" onClick={closeAlert}>
            <CloseIcon />
          </IconButton>
        }
        sx={{mb: 2}}
      >
        {text}
      </Alert>
    </Collapse>
  );
};

export default CustomAlert;
